<template>
  <div class="retrieve-password">
    <div class="nav">
      <router-link class="logo" to="/login" replace>
        <img src="../assets/img/icon/logo.png">
        <span>{{$app_name}}</span>
      </router-link>
      <div class="nav-text">密码找回</div>
    </div>
    <div class="panel">
      <el-row type="flex" justify="center" class="steps-wrap">
        <el-steps class='steps' space="30vw" :active="steps" finish-status="finish" center align-center>
          <el-step title="验证身份"></el-step>
          <el-step title="找回密码"></el-step>
          <el-step title="完成"></el-step>
        </el-steps>
      </el-row>
      <step-1 :steps.sync="steps" v-if="steps === 1"></step-1>
      <step-2 :steps.sync="steps" v-if="steps === 2"></step-2>
      <step-3 :steps.sync="steps" v-if="steps === 3"></step-3>
    </div>
  </div>
</template>

<script>
import * as step1 from './password/step1'
import * as step2 from './password/step2'
import * as step3 from './password/step3'

export default {
  data () {
    return {
      steps: 1,
    }
  },
  components: {
    'step-1': step1,
    'step-2': step2,
    'step-3': step3,
  },
  beforeRouteLeave (to, from, next) {
    this.$confirm('是否确定退出当前页面?', '提示', {confirmButtonText: '离开'}).then(next)
  },
}
</script>

<style scoped lang="scss">
@import "src/scss/var/colors";
@import "src/scss/var/app";

$padding: $page-padding;
.retrieve-password {
  .nav {
    padding: 0 $padding;
    color: $color-primary;
    display: flex;
    align-items: center;
    background: white;
    box-shadow: 0 1px 5px -2px $color-border;
    .logo {
      font-size: 1.5rem;
      font-weight: bold;
      display: flex;
      align-items: center;
      color: $color-primary;
      margin: 8px 10px;
      cursor: pointer;
      img {
        height: 1.5em;
        width: 1.5em;
        line-height: 1;
      }
      text-decoration: none;
    }
    .nav-text {
      color: $color-normal;
    }
  }
  .panel {
    width: 100%;
    .steps-wrap {
      margin-top: 50px;
    }
  }
  .footer {
    text-align: center;
    font-size: 0.8rem;
    color: $color-grey;
    position: fixed;
    bottom: 0;
    left: 0;
    right: 0;
  }
}
</style>



// WEBPACK FOOTER //
// src/components/RetrievePassword.vue